import React, { useState, ChangeEvent, FormEvent } from 'react';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { FirebaseClient } from '../../firebase/FirebaseClient';
import { createUserDetails } from '../../requests/blueprintRequests';
import { IUserCreate } from '../../types/blueprint';

type FormData = {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  phoneNumber: string;
  password: string;
  confirmPassword: string;
  streetAddress: string;
  city: string;
  postcode: string;
  state: string;
  country: string;
};

const countries = [
  // You might want to get a more comprehensive list of countries.
  'Australia',
];

const states = ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'];

const Signup: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    firstName: '',
    lastName: '',
    username: '',
    email: '',
    phoneNumber: '',
    password: '',
    confirmPassword: '',
    streetAddress: '',
    city: '',
    postcode: '',
    state: '',
    country: '',
  });

  const [alert, setAlert] = useState<string | null>(null);
  // const [error, setError] = useState<string | null>(null);

  const history = useHistory();

  const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setAlert('Passwords do not match!');
      return;
    }

    // TODO: Handle registration logic here
    const fbAuth = FirebaseClient.getInstance().getFirebaseAuth();
    fbAuth.createUserWithEmailAndPassword(formData.email, formData.password)
      .then(createUserRet => {
        console.log(createUserRet)
        console.log(fbAuth.currentUser?.uid)
        fbAuth.currentUser?.getIdToken()
          .then(jwt => {

            const userCreate: IUserCreate = {
              id: fbAuth.currentUser?.uid ? fbAuth.currentUser?.uid : '',
              data: {
                firstName: formData.firstName,
                lastName: formData.lastName,
                phoneNumber: formData.phoneNumber,
                emailAddress: formData.email,
                address: {
                  streetAddress: formData.streetAddress,
                  city: formData.city,
                  postalCode: formData.postcode,
                  state: formData.state,
                  countryCode: formData.country
                }

              }
            }
            createUserDetails(jwt, userCreate).then(userDetailsRet => {
              setAlert('Registration successful!');
              history.push('/')
            })
              .catch(err => {
                setAlert('User details create failed : ' + err.message)
              })
          })

      })
      .catch(err => {
        setAlert(err.message);
      })
  };

  return (
    <Container>
      <Row className="justify-content-md-center mt-5">
        <Col md={6}>
          <h2>Signup</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="firstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="lastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="email">
              <Form.Label> Phone number</Form.Label>
              <Form.Control
                type="number"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="email">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="confirmPassword">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="streetAddress">
              <Form.Label>Street Address</Form.Label>
              <Form.Control
                type="text"
                name="streetAddress"
                value={formData.streetAddress}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="city">
              <Form.Label>City</Form.Label>
              <Form.Control
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="postcode">
              <Form.Label>Postcode</Form.Label>
              <Form.Control
                type="text"
                name="postcode"
                value={formData.postcode}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="state">
              <Form.Label>State</Form.Label>
              <Form.Control as="select"
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                required
              >
                <option value="">Select a state...</option>
                {states.map(state => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="country">
              <Form.Label>Country</Form.Label>
              <Form.Control as="select"
                name="country"
                value={formData.country}
                onChange={handleChange}
                required
              >
                {/* <option value="">Select a country...</option> */}
                {countries.map(country => (
                  <option key={country} value={country}>
                    {country}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group>

              <Button variant="primary" type="submit">
                Register
              </Button>
            </Form.Group>
            <br></br>
            <Form.Group>
              <Col xs={12}>
                {alert && <Alert variant='warning'>{alert}</Alert>}
              </Col>
            </Form.Group>
            <Form.Group>

              <Col>
                <div className='login-link'>
                  <Link to='/log-in'>Already have a account? Please log in</Link>
                </div>
              </Col>
            </Form.Group>
          </Form>
        </Col>
      </Row>

    </Container>
  );
};

export default Signup;
